import script from "./PosBatchAdd.vue?vue&type=script&lang=ts&setup=true"
export * from "./PosBatchAdd.vue?vue&type=script&lang=ts&setup=true"

import "./PosBatchAdd.vue?vue&type=style&index=0&id=11264f12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11264f12"]])

export default __exports__